module.exports = __webpack_public_path__ + "img/icon5.da2c89e8.png";